export default __webpack_public_path__ + "static/media/Snd_ClowerN.a9802665.mp3";